import React from 'react';

// import LinkTelegram from './linkTelegram/linkTelegram';

export const columns = [
  {
    //0
    name: 'id',
    label: '',
    options: {
      filter: false,
      sort: false,
      display: 'excluded',
    },
  },

  {
    //1
    name: 'name',
    label: 'Nome',
    options: {
      setCellHeaderProps: () => ({
        style: {
          'text-align': 'center',
        },
      }),
      setCellProps: () => ({
        style: {
          'text-align': 'center',
        },
      }),
      setCellHeaderProps: () => ({
        style: {
          'text-align': 'center',
        },
      }),
      filter: false,
      sort: false,
    },
  },
  {
    //1
    name: 'contract_item',
    label: 'Equipamento',
    options: {
      setCellHeaderProps: () => ({
        style: {
          'text-align': 'center',
        },
      }),
      setCellProps: () => ({
        style: {
          'text-align': 'center',
        },
      }),
      setCellHeaderProps: () => ({
        style: {
          'text-align': 'center',
        },
      }),
      filter: false,
      sort: false,
      customBodyRender: (value, tableMeta) => {
        return value.nickname + '(' + value.serial + ')';
      },
    },
  },

  // {
  //   //1
  //   name: 'chat_id',
  //   label: 'Vincular',
  //   options: {
  //     setCellHeaderProps: () => ({
  //       style: {
  //         'text-align': 'center',
  //       },
  //     }),
  //     setCellProps: () => ({
  //       style: {
  //         'text-align': 'center',
  //       },
  //     }),
  //     setCellHeaderProps: () => ({
  //       style: {
  //         'text-align': 'center',
  //         width: '20%',
  //       },
  //     }),
  //     filter: false,
  //     sort: false,
  //     customBodyRender: (value, tableMeta) => {
  //       return <LinkTelegram chatId={value} />;
  //     },
  //   },
  // },
];
